
<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">          
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    <div class="Wrapper">
        <h3>This project has been withdraw by sender</h3>
        <!-- <h5> You'll Receive an Email contaning link for signature.
            </h5> -->
        <!-- <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div> -->
        <!-- <a class="register" href="http://flowtrics.com/"  mat-stroked-button color="primary"  type="button">Get Started</a> -->
    </div> 
</div>

